<template>
    <div>
        <div >
            <div class="channel">
                <!-- <div class="title">{{channelTitle}}渠道提报</div> -->
                <!-- <div class="type-tab">
                    <el-tabs  type="card" @tab-click="handleClick" :value="getActiveName(tabArr)" >
                        <el-tab-pane
                        v-for="(item) in tabArr"
                        :key="item.themeStyleCode "
                        :label="item.themeStyleName"
                        :name="item.themeStyleName"
                        >
                            <div class="child" v-if="item.data[0].themeDetail.themeLevelCode !==null">
                                <el-tabs  v-model="activeName" tab-position="left" @tab-click="handleClickson" >
                                    <el-tab-pane
                                    v-for="(i) in item.data"
                                    :key="i.themeDetail.themeLevelCode"
                                    :label="i.themeDetail.themeLevelName"
                                    :name="i.themeDetail.themeLevelName"
                                    >
                                        <PopForm
                                        @clickStorename="clickStorename"
                                        :popDataitem="i"
                                        :themeBasic = 'themeBasic'
                                        :queryCondition="queryCondition"
                                        :igniteOptions="igniteOptions"
                                        :regionCode="regionCode"
                                        :routerType="routerType"
                                            ></PopForm>
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                            <div class="father" v-else>
                                <PopForm
                                    @clickStorename="clickStorename"
                                    :popDataitem="item"
                                    :themeBasic = 'themeBasic'
                                    :queryCondition="queryCondition"
                                    :igniteOptions="igniteOptions"
                                    :regionCode="regionCode"
                                    :routerType="routerType"
                                    >
                                </PopForm>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div> -->
                <PopForm
                    @clickStorename="clickStorename"
                    :popDataitem="dataForm"
                    :themeBasic = 'themeBasic'
                    :queryCondition="queryCondition"
                    :igniteOptions="igniteOptions"
                    :regionCode="regionCode"
                    :routerType="routerType"
                    @activityChanged="activityChanged"
                    >
                </PopForm>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import PopForm from './activity-report-pop-form.vue'
    export default {
      name: 'activity-report-pop',
      props: {
        channelForm:{type:Object,default:()=>{}},
        dataForm:{type:Object,default:()=>{}},
        queryCondition:{type:String},
        igniteOptions:{type:Object, default:()=>{} },
        themeBasic:{type:Object, default:()=>{} },
        regionCode:{type:String, default:'' },
        routerType:{type:String, default:'' },
      },
      components: {
        PopForm
      },
      data () {
        return {
            tabList:[],
            tabName:'地标',
            childName:'',
            tabArr: [],
            activeName: '',
            tabIndex: '',
            channelTitle:'',
            itemData: '',
            allList:[],
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.init()
      },
      mounted () {
        // const tab = {index: 0}
        // this.handleClick(tab)
      },
      updated () {
      },
      methods: {
        init () {
            // this.getChannelitem()
            // this.getAllList()
        },
        activityChanged () {
            this.$emit('activityChanged')
        },
        getChannelitem () {
            this.channelTitle = this.channelForm.themeChannelEnName
            let code = this.channelForm.themeChannelCode
            let itemList = []
            for (let i = 0; i < this.dataForm.length; i++) {
                if (code === this.dataForm[i].themeDetail.themeChannelCode) {
                        itemList.push({
                            'themeDetail':this.dataForm[i].themeDetail,
                            'gpActivityInfoVOList':this.dataForm[i].gpActivityInfoVOList,
                            'igniteRuleDTOList':this.dataForm[i].igniteRuleDTOList,
                            'curAssignList':this.dataForm[i].curAssignList
                        })
            }}
            this.allList = itemList
            this.getTaball(this.allList)
        },
        getAllList () {
            let itemIndex = []
            for (let item of this.allList) {
                let index = itemIndex.indexOf(item.themeDetail.themeStyleCode)
                if (index === -1) {
                    itemIndex.splice(0,0,item.themeDetail.themeStyleCode)
                    let data = [
                        {
                        'themeLevelCode':item.themeDetail.themeLevelCode ,
                        'themeStyleName':item.themeDetail.themeStyleName,
                        'themeStyleCode':item.themeDetail.themeStyleCode,
                        'themeDetail':item.themeDetail,
                        'gpActivityInfoVOList':item.gpActivityInfoVOList
                        }
                    ]
                    this.tabArr.push(data)

                } else {
                    this.tabArr[index].push(
                        {
                            'themeLevelCode':item.themeDetail.themeLevelCode,
                            'themeStyleName':item.themeDetail.themeStyleName,
                            'themeStyleCode':item.themeDetail.themeStyleCode,
                            'themeDetail':item.themeDetail,
                            'gpActivityInfoVOList':item.gpActivityInfoVOList
                        }
                    )
                }
            }
            this.tabList =  this.tabArr.map((item)=>{
                return item.themeStyleName || item[0].themeDetail.themeStyleName
            }).join('、')
        },
        getTaball (arr) {
            let map = {}
            let dest = [];
            for(let i = 0; i < arr.length; i++){
                let ai = arr[i];
                if(!map[ai.themeDetail.themeStyleCode]){
                    dest.push({
                        'themeStyleCode': ai.themeDetail.themeStyleCode,
                        'themeStyleName': ai.themeDetail.themeStyleName,
                        'themeLevelCode':ai.themeDetail.themeLevelCode,
                        'themeLevelName':ai.themeDetail.themeLevelName,
                        // 'themeBasic':this.themeBasic,
                        data: [ai]
                    });
                    map[ai.themeDetail.themeStyleCode] = ai;
                }else{
                    for(let j = 0; j < dest.length; j++){
                        let dj = dest[j];
                        if(dj.themeStyleCode == ai.themeDetail.themeStyleCode){
                            dj.data.push(ai);
                            break;
                        }
                    }
                }
            }
            // console.log(dest,'dest');
            this.tabArr = dest
            this.tabList =  this.tabArr.map((item)=>{
                return item.themeStyleName
            }).join('、')
            return dest
        },
        clickStorename (row) {
            this.$emit("clickStorename",row)
        },
        getActiveName(tabArr) {
            if (tabArr[0].data[0].themeDetail.themeLevelCode !==null) {
                this.activeName = tabArr[0].data[0].themeDetail.themeLevelName
                return tabArr[0].themeStyleName
            } else {
                return tabArr[0].themeStyleName

            }
        },
        handleClick(tab) {
            let num = Number(tab.index)
            this.tabIndex = num
            if (this.tabArr[num].data[0].themeDetail.themeLevelCode !==null) {
                this.activeName = this.tabArr[num].data[0].themeDetail.themeLevelName
                return this.tabArr[num].themeStyleName
            } else {
                return this.tabArr[num].themeStyleName
            }
        },
        handleClickson (tab) {
            // console.log(tab,'son');
        }
    }
}
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
        .channel {
            margin-top: 40px;
            .title {
                height: 50px;
                line-height: 50px;
                text-align: left;
                color: rgba(16, 16, 16, 1);
                font-size: 18px;
                font-weight: 600;
            }
            .type-tab {
                margin-top: 20px;
                ::v-deep .el-tabs__item.is-active {
                    background-color: #409EFF;
                    color: #FFFFFF;
                }
                ::v-deep .el-tabs__item {
                    color: #101010;
                    background-color: #FFFFFF;
                    // border: 0;
                    // width: 190px;
                    // height: 42px;
                    // border-radius: 4px;
                    // text-align: center;
                    // margin-right: 5px;
                    // border-radius: 10px;

                    text-align: center;
                    margin-right: 5px;
                    min-width: 100px;
                    border: none;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                    height: 42px;
                    padding: 0px !important;
                }
                ::v-deep .el-tabs__nav-scroll {
                    border-bottom: 0;
                }
                ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
                    border: 0;
                    margin-bottom: 0;
                }
                ::v-deep .el-tabs--card>.el-tabs__header {
                    border-bottom: 0px solid #E4E7ED;
                }
                // ::v-deep .el-tabs__content {
                //     overflow: hidden;
                //     position: relative;
                //     margin-top: -15px;
                //     background-color: #FFFFFF;
                //     padding: 20px 0px 0px 0px;
                //     border-radius: 8px;
                //     border-top-left-radius: 0px;
                // }
                .child {
                    background-color: #FFFFFF;
                    ::v-deep .el-tabs__item.is-active {
                    background-color: rgba(255, 255, 255, .1);
                    color: #409EFF;
                    }
                    ::v-deep .el-tabs__item {
                        color: #101010;
                        background-color: rgba(255, 255, 255, .1);
                        // border: 0;
                        // width: 140px;
                        // height: 42px;
                        // border-radius: 4px;
                        text-align: center;
                        // margin-bottom: 10px;
                    }
                    ::v-deep .el-tabs__nav-scroll {
                        border-bottom: 0;
                    }
                    ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
                        border: 0;
                        margin-bottom: 0;
                    }
                }
            }
        }

</style>
